 


import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const projectRoutes: RouteObject[] = [
  {
    path: 'PROJECT/*',
    children: [
      // ==========================
      // PM (new)
      // ==========================
      { path: 'ProjectsList2', lazy: lazyRoute(() => import('../../pages/PM/ProjectList/ProjectList')) },
      { path: 'AddProject', lazy: lazyRoute(() => import('../../pages/PM/ProjectList/ProjectForm')) },
      { path: 'UpdateProject/:projectId', lazy: lazyRoute(() => import('../../pages/PM/ProjectList/ProjectForm')) },
      { path: 'ProjectHub/:projectId', lazy: lazyRoute(() => import('../../pages/PM/ProjectHub/ProjectHubPage')) },

      // -------------------------------------------------------------------------------------
      // 🆕 المسار الجديد للصفحة المركزية للمشروع (PROJECT app)
      { path: 'project-hub/:projectId', lazy: lazyRoute(() => import('../../pages/PROJECT/ProjectHub/ProjectHubPage')) },

      // الصفحة الرئيسية
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/PROJECT/HomePage/ProjectHomePage')) },

      // صفحات مباشرة كانت import (حوّلناها lazy)
      { path: 'ProjectOverview', lazy: lazyRoute(() => import('../../pages/PROJECT/Overview/ProjectOverviewPage')) },
      { path: 'ProjectBoard', lazy: lazyRoute(() => import('../../pages/PROJECT/Board/ProjectBoardPage')) },
      { path: 'ProjectReports', lazy: lazyRoute(() => import('../../pages/PROJECT/Reports/ProjectReportsPage')) },

      // المشاريع
      { path: 'ProjectsList', lazy: lazyRoute(() => import('../../pages/PROJECT/ProjectsList/ProjectBoard')) },

      // إضافة/تعديل مشروع (كانت import مباشر)
      { path: 'AddOrEditProject', lazy: lazyRoute(() => import('../../pages/PROJECT/Details/AddOrEditProject')) },

      // مراحل المشروع
      { path: 'ProjectPhases', lazy: lazyRoute(() => import('../../pages/PROJECT/Phases/ProjectPhasesPage')) },

      // الميزانية
      { path: 'ProjectBudgets', lazy: lazyRoute(() => import('../../pages/PROJECT/Budget/ProjectBudgetsPage')) },

      // التكاليف
      { path: 'ProjectCostItems', lazy: lazyRoute(() => import('../../pages/PROJECT/Costs/ProjectCostItemsPage')) },

      // العقود
      { path: 'ProjectContracts', lazy: lazyRoute(() => import('../../pages/PROJECT/Contracts/ProjectContractsPage')) },

      // التتبع
      { path: 'ProjectTracking', lazy: lazyRoute(() => import('../../pages/PROJECT/Tracking/ProjectTrackingPage')) },

      // الحوادث
      { path: 'ProjectIncidents', lazy: lazyRoute(() => import('../../pages/PROJECT/Incidents/ProjectIncidentsPage')) }
    ]
  }
];

export default projectRoutes;
